
import Event from "@/models/Event";
import {getBusinessCardsDoc, getEventDoc} from "@/shared/firebase_utils";
const state = {
  currentEvent: null,
  registrants: []
};

const getters = {
  currentEvent: (state) => state.currentEvent,
  registrants: (state) => state.registrants,
  // noOfChatroomsEnabled: (state) => {
    
  // }
};

const actions = {
  async setCurrentEvent({ commit }, payload) {
    await commit("setCurrentEvent", payload);
  },
  async initializeCurrentEvent({ commit }, eventId) {
    try {
      //Read data from firestore
      let doc = await getEventDoc(eventId);

      commit("setCurrentEvent", Event.fromFireStore(doc));
    } catch (error) {
      console.log("Error initialising event: ", error);
    }
  },
  clearCurrentEvent({commit}){
    commit("clearCurrentEvent");
  },
  getRegistrants({ commit },attendees){

    let linkRegistrants = [];
    attendees.forEach((attendee) => {
      if (attendee.businessCardId != "") {
        let isBusinessCardRetrieved = false;

        for (let i = 0; i < linkRegistrants.length; i++) {
          if (linkRegistrants[i].id == attendee.businessCardId) {
            isBusinessCardRetrieved = true;
            break;
          }
        }

        if (!isBusinessCardRetrieved) {
          getBusinessCardsDoc(attendee.businessCardId)
            .then((doc) => {
              if (doc.exists)
                linkRegistrants.push({
                  id: doc.id,
                  ...attendee,
                  invitedEmail: attendee.email,
                  attendeeUid: attendee.uid,
                  ...doc.data(),
                });
            });
        }
      }
    });

    //Remove attendee from linkRegistrants
    linkRegistrants.forEach((registrant, index) => {
      let isRegistrantRemoved = true;

      for (let i = 0; i < attendees.length; i++) {
        if (registrant.id == attendees[i].businessCardId) {
          isRegistrantRemoved = false;
          break;
        }
      }

      if (isRegistrantRemoved) linkRegistrants.splice(index, 1);
    });

    commit("setRegistrants",linkRegistrants);
  }
};

const mutations = {
  setCurrentEvent: (state, currentEvent) => {
    state.currentEvent = currentEvent;
  },
  clearCurrentEvent: (state) => {
    state.currentEvent = null;
  },
  setRegistrants: (state, registrants) => {
    state.registrants = registrants;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
